<template>
  <div class="sa-card sa-card-border sa-card-noshadow">
    <avtar
      :editBoolean="editBoolean"
      @editFlag="pflag = $event"
      @imgEvent="imgUrl = $event"
    />
    <form @submit.prevent>
      <div class="sa-tit-heading sa-h-sm-up">Certifications</div>

      <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Awards</label>
            <!-- <input
              @input="certificReq.awds = certificReq.awds.split(',')"
              v-model="certificReq.awds"
              type="text"
              class="sa-form-control"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            />-->
            <v-select
              :options="certificReq.certifications.awards"
              v-model="certificReq.certifications.awards"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag ? 'sa-disabled' : ''"
              id="awards"
              name="Awards"
              ><span slot="no-options">No data</span></v-select
            >
          </div>
        </div>
        <div v-if="pflag" class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Awards in (Arabic)</label>
            <!-- <input
              @input="certificReq.awds = certificReq.awds.split(',')"
              v-model="certificReq.awds"
              type="text"
              class="sa-form-control"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            />-->
            <v-select
              :options="certificReq.certifications.awards_ar"
              v-model="certificReq.certifications.awards_ar"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag ? 'sa-disabled' : ''"
              id="awardsInAr"
              name="Awards in Arabic"
              ><span slot="no-options">No data</span></v-select
            >
          </div>
        </div>
      </div>
      <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Attachment</label>
            <file-upload-multiple
              :pflag="pflag"
              :fileData="certificReq.certifications.awards_att"
              v-on:file-upload-success="setImg($event, 'awds')"
            />
          </div>
        </div>
      </div>
      <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Publications</label>
            <!-- <input
              @input="certificReq.publ = certificReq.publ.split(',')"
              v-model="certificReq.publ"
              type="text"
              class="sa-form-control"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            />-->
            <v-select
              :options="certificReq.certifications.publ"
              v-model="certificReq.certifications.publ"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag ? 'sa-disabled' : ''"
              id="publications"
              name="Publications"
              ><span slot="no-options">No data</span></v-select
            >
          </div>
        </div>
        <div v-if="pflag" class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Publications in (Arabic)</label>
            <!-- <input
              @input="certificReq.publ = certificReq.publ.split(',')"
              v-model="certificReq.publ"
              type="text"
              class="sa-form-control"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            />-->
            <v-select
              :options="certificReq.certifications.publ_ar"
              v-model="certificReq.certifications.publ_ar"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag ? 'sa-disabled' : ''"
              id="publicationsAr"
              name="publicationsAr"
              ><span slot="no-options">No data</span></v-select
            >
          </div>
        </div>
      </div>
      <!-- <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
          <div class="sa-form-group">
            <label>Membership</label>
            <v-select
              :options="certificReq.certifications.publ"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            ><span slot="no-options">No data</span></v-select>
          </div>
        </div>
        <div v-if="pflag" class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
          <div class="sa-form-group">
            <label>Membership in (Arabic)</label>
            <v-select
              :options="certificReq.certifications.publ"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            ><span slot="no-options">No data</span></v-select>
          </div>
        </div>
      </div> -->
      <!-- <div class="sa-row">
          <div class="sa-col-xs6 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <ValidationProvider
              name="Clinical experience  in english"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>
                Clinical experience
                <span class="sa-red-text">*</span>
              </label>
              <input
                v-model="exp"
                type="text"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
          <div v-if="pflag" class="sa-col-xs6 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <ValidationProvider
              name="Clinical experience  in english"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>
                Clinical experience  in (Arabic)
              </label>
              <input
                v-model="exp"
                type="text"
                class="sa-form-control"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              />
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
      </div> -->
      <!-- <div v-if="pflag" class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <ValidationProvider
              name="Date of Birth"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>From Date </label>
              <i class="icon-picker sa-form-icon sa-f-size16 "></i>
                <vc-date-picker :max-date="new Date()" v-model="exp" class="sa-edit-date"> 
                <input
                  id="date"
                  readonly
                  class="sa-form-control"
                  slot-scope="{ inputProps, inputEvents, isDragging }"
                  :class="[`${!pflag?'sa-disabled':''}  ${isDragging ? '' : '' }`, { '': 'errorMessage' }]"
                  :disabled="!pflag"
                  v-bind="inputProps"
                />
              </vc-date-picker>
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
           <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
            <ValidationProvider
              name="Date of Birth"
              rules="required"
              v-slot="{ errors }"
              tag="div"
              class="sa-form-group"
            >
              <label>To Date </label>
              <i class="icon-picker sa-form-icon sa-f-size16 "></i>
                <vc-date-picker :max-date="new Date()" v-model="exp" class="sa-edit-date"> 
                <input
                  id="date"
                  readonly
                  class="sa-form-control"
                  slot-scope="{ inputProps, inputEvents, isDragging }"
                  :class="[`${!pflag?'sa-disabled':''}  ${isDragging ? '' : '' }`, { '': 'errorMessage' }]"
                  :disabled="!pflag"
                  v-bind="inputProps"
                />
              </vc-date-picker>
              <span class="sa-val-err">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
      </div> -->
      <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md8 sa-col-lg12">
          <div class="sa-form-group">
            <label> Attachment</label>
            <div class="sa-row">
              <div
                class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4"
                :disabled="!pflag"
                :class="!pflag?'sa-disabled':''"
              >
                <file-upload-multiple v-on:file-upload-success="setImg($event, 'awds')" />
              </div>
              <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg6">
                <div class="sa-f-up-doc sa-mt10">
                  <a :href="img_awds" target="_blank" class="sa-f-up-info" v-if="isImage(icon_awds)">
                    <img :src="img_awds" alt />
                  </a>
                  <a :href="img_awds" download class="sa-f-up-info" v-else>
                    <i :class="attachAwdsIcons"></i>
                  </a>
                  <a 
                    class="sa-f-up-name sa-ellipsis"
                    v-if="imgName_awds"
                  >{{ imgName_awds }}</a>
                </div>
              </div>
            </div>
          </div>
      </div>-->
      <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg4">
          <div class="sa-form-group">
            <label>Certfications</label>
            <!-- <input
              @input="certificReq.certs = certificReq.certs.split(',')"
              v-model="certificReq.certs"
              type="text"
              class="sa-form-control"
              :disabled="!pflag"
              :class="!pflag?'sa-disabled':''"
            />-->
            <v-select
              :options="certificReq.certifications.certs"
              v-model="certificReq.certifications.certs"
              taggable
              multiple
              class="sa-multiple-tag"
              :disabled="!pflag"
              :class="!pflag ? 'sa-disabled' : ''"
              id="Certfications"
              name="Certfications"
              ><span slot="no-options">No data</span></v-select
            >
          </div>
        </div>
        <!-- <div class="sa-col-xs12 sa-col-sm6 sa-col-md4 sa-col-lg4">
          <div class="sa-form-group">
            <label>Specialist</label>
            <span :disabled="!pflag" :class="!pflag?'sa-disabled sa-d-none ':'sa-p-checkbox '">
              <input type="checkbox" id="checkbox" />
              <label for="checkbox">Is Specialist</label>
            </span>
            <span :disabled="!pflag" :class="!pflag?'':'sa-d-none'">
              <span class="sa-status-active sa-mr10"></span>
              <span class="sa-green-text">Is Specialist</span>
            </span>
          </div>
        </div> -->
      </div>
      <div class="sa-row">
        <div class="sa-col-xs12 sa-col-sm6 sa-col-md6 sa-col-lg8">
          <div class="sa-form-group">
            <label>Attachment</label>
            <div class="sa-row">
              <div class="sa-col-xs12 sa-col-sm12 sa-col-md12 sa-col-lg6">
                <file-upload-multiple
                  :pflag="pflag"
                  :fileData="certificReq.certifications.certi_att"
                  v-on:file-upload-success="setImg($event, 'certs')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="pflag" class="sa-text-right">
        <button
          class="sa-btn sa-btn-primary sa-btn-block-xs"
          @click="updateProfile()"
        >
          Save
        </button>
      </div>
    </form>
    <div class="sa-dialog-white" v-if="loader">
      <img src="../../assets/img/loader.svg" alt="loader" class="sa-loader" />
    </div>
  </div>
</template>
<script>
import AvtarVue from "../common/Avtar.vue";

import { pro_url } from "../../../config/endpoints";
import { oh_url, com_url } from "../../../config/endpoints";
import FileUploadMultipleVue from "../common/FileUploadMultiple.vue";
export default {
  props: ["pInfo"],
  components: {
    "file-upload-multiple": FileUploadMultipleVue,
    avtar: AvtarVue,
  },
  data() {
    return {
      imgUrl: null,
      date: new Date(2018, 0, 25),
      imageFormat: [
        "jpg",
        "jpeg",
        "png",
        "gif",
        "bmp",
        "tif",
        "tiff",
        "eps",
        "raw",
        "cr2",
        "nef",
        "orf",
        "sr2",
        "PSD",
        "XCF",
        "AI",
        "CDR",
      ],
      exp: "",
      file_type: null,
      icon_certs: null,
      icon_awds: null,
      editBoolean: false,
      loader: false,
      pflag: false,
      img_certs: "",
      imgName_certs: "",
      img_awds: "",
      imgName_awds: "",
      selectawards: [],
      selectfellowship: [],
      certificReq: {
        mtype: "certifications",
        certifications: {
          img: "",
          awards: ["awards"],
          awards_ar: ["awards"],
          awards_att: [
            {
              name: "img.jpg",
              url:
                "https://img.litedev.com/mis/a6a7a6ac8bf17abe2988d088d16102e7.jpg",
            },
          ],
          publ: ["publications"],
          publ_ar: ["publications arabic"],
          certs: ["certifications"],
          certi_att: [
            {
              name: "img.jpg",
              url:
                "https://img.litedev.com/mis/a6a7a6ac8bf17abe2988d088d16102e7.jpg",
            },
          ],
        },
      },
    };
  },
  methods: {
    isImage(fileType) {
      if (this.imageFormat.includes(fileType)) {
        return true;
      }
      return false;
    },
    setImg(uimg, flag) {
      let _self = this;
      if (flag == "certs") {
        _self.img_certs = uimg.url;
        _self.imgName_certs = uimg.filename;
        _self.icon_certs = uimg.filename.split(".")[1] || null;
        _self.certificReq.certifications["certi_att"].push({
          name: uimg.filename,
          url: uimg.url,
        });
      } else if (flag == "awds") {
        _self.img_awds = uimg.url;
        _self.imgName_awds = uimg.filename;
        _self.icon_awds = uimg.filename.split(".")[1] || null;
        _self.certificReq.certifications["awards_att"].push({
          name: uimg.filename,
          url: uimg.url,
        });
      }
    },
    setProfileData() {
      let _self = this;
      _self.certificReq.certifications = _self.pInfo.certifications;
      // _self.certificReq.awds = _self.pInfo.awards;
      // _self.certificReq.certs = _self.pInfo.certs;
      // _self.certificReq.publ = _self.pInfo.publ;
      // _self.certificReq.certi_att = _self.pInfo.certi_att;
      // _self.certificReq.awards_att = _self.pInfo.awards_att;
      // if (_self.pInfo.certi_att.length) {
      //   _self.img_certs = _self.pInfo.certi_att[0].url;
      //   _self.icon_certs = _self.pInfo.certi_att[0].name.split(".")[1] || null;
      //   _self.imgName_certs = _self.pInfo.certi_att[0].name;
      // }
      // if (_self.pInfo.awards_att.length) {
      //   _self.img_awds = _self.pInfo.awards_att[0].url;
      //   _self.icon_awds = _self.pInfo.awards_att[0].name.split(".")[1] || null;
      //   _self.imgName_awds = _self.pInfo.awards_att[0].name;
      // }
    },
    updateProfile(obj, params) {
      let _self = this;
      _self.loader = true;
      // _self.certificReq.awds = _self.certificReq.awds.filter(
      //   (e) => e.trim() != ""
      // );
      // _self.certificReq.certs = _self.certificReq.certs.filter(
      //   (e) => e.trim() != ""
      // );
      // _self.certificReq.publ = _self.certificReq.publ.filter(
      //   (e) => e.trim() != ""
      // );
      if (_self.imgUrl) {
        _self.certificReq.certifications.img = _self.imgUrl;
        let userInfo = JSON.parse(_self.$localStorage.get("userdata")) || {};
        userInfo.img = _self.imgUrl;
        _self.$localStorage.set(
          "userdata",
          JSON.stringify(userInfo),
          60 * 60 * 2 + 55
        );
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/addProfile`,
          body: _self.certificReq,
        })
        .then((response) => {
          if (response && response.status === 1000) {
            _self.$parent.getUserData();
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Certification updated successfully",
              class: "sa-a-success",
            });
          } else if (response && response.status == "2001") {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Session Expired. Please login again",
              class: "sa-a-danger",
            });
            _self.$localStorage.remove("token");
            _self.$localStorage.remove("userdata");
            _self.$router.push({ path: "/" });
          } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: "Something went wrong",
              class: "sa-a-danger",
            });
          }
          _self.loader = false;
        })
        .catch((e) => {
          _self.$store.dispatch("SET_ALERTMESSAGE", {
            msg: "Something went wrong",
            class: "sa-a-danger",
          });
          _self.loader = false;
        });
    },
    saveProfile() {
      let _self = this;
      let p = _self.pInfo;
      if (_self.img) {
        p.img = _self.img;
      }
      _self.$parent.updateProfile(p);
    },
  },
  computed: {
    attachAwdsIcons() {
      return "icon-" + this.icon_awds;
    },
    attachCertsIcons() {
      return "icon-" + this.icon_certs;
    },
  },
  created() {
    this.setProfileData();
  },
  watch: {
    pflag: {
      immediate: true,
      deep: true,
      handler() {
        let _self = this;
        _self.editBoolean = _self.pflag;
      },
    },
  },
};
</script>
